// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_SESSION_MANAGER = "sessionManager"; // Count: 3
export var _DYN_UPDATE = "update"; // Count: 4
export var _DYN_IS_USER_COOKIE_SET = "isUserCookieSet"; // Count: 4
export var _DYN_IS_NEW_USER = "isNewUser"; // Count: 4
export var _DYN_GET_TRACE_CTX = "getTraceCtx"; // Count: 3
export var _DYN_TELEMETRY_TRACE = "telemetryTrace"; // Count: 3
export var _DYN_APPLY_SESSION_CONTEX0 = "applySessionContext"; // Count: 2
export var _DYN_APPLY_APPLICATION_CO1 = "applyApplicationContext"; // Count: 2
export var _DYN_APPLY_DEVICE_CONTEXT = "applyDeviceContext"; // Count: 2
export var _DYN_APPLY_OPERATION_CONT2 = "applyOperationContext"; // Count: 2
export var _DYN_APPLY_USER_CONTEXT = "applyUserContext"; // Count: 2
export var _DYN_APPLY_OPERATING_SYST3 = "applyOperatingSystemContxt"; // Count: 2
export var _DYN_APPLY_LOCATION_CONTE4 = "applyLocationContext"; // Count: 2
export var _DYN_APPLY_INTERNAL_CONTE5 = "applyInternalContext"; // Count: 2
export var _DYN_ACCOUNT_ID = "accountId"; // Count: 7
export var _DYN_GET_SESSION_ID = "getSessionId"; // Count: 4
export var _DYN_NAME_PREFIX = "namePrefix"; // Count: 3
export var _DYN_SESSION_COOKIE_POSTF6 = "sessionCookiePostfix"; // Count: 2
export var _DYN_USER_COOKIE_POSTFIX = "userCookiePostfix"; // Count: 2
export var _DYN_ID_LENGTH = "idLength"; // Count: 4
export var _DYN_GET_NEW_ID = "getNewId"; // Count: 3
export var _DYN_LENGTH = "length"; // Count: 4
export var _DYN_AUTOMATIC_SESSION = "automaticSession"; // Count: 5
export var _DYN_AUTHENTICATED_ID = "authenticatedId"; // Count: 6
export var _DYN_ACQUISITION_DATE = "acquisitionDate"; // Count: 5
export var _DYN_RENEWAL_DATE = "renewalDate"; // Count: 4
export var _DYN_JOIN = "join"; // Count: 5
export var _DYN_COOKIE_SEPARATOR = "cookieSeparator"; // Count: 5
export var _DYN_AUTH_USER_COOKIE_NAM7 = "authUserCookieName"; // Count: 3
//# sourceMappingURL=__DynamicConstants.js.map